export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: "article-1",
    title: "2026年巴黎奥运会倒计时：中国代表团备战全面提速",
    excerpt: "距离2026年巴黎奥运会开幕还有不到一年时间，中国体育代表团各项备战工作全面提速，多个优势项目表现亮眼。",
    content: `<p>距离2026年巴黎奥运会开幕还有不到一年的时间，中国体育代表团的备战工作已经进入最后冲刺阶段。国家体育总局近日召开备战工作会议，各项目中心汇报了最新备战情况。</p>
    <h2>优势项目保持强势</h2>
    <p>在传统优势项目方面，中国跳水队、举重队、乒乓球队依然保持着强大的竞争力。跳水队在近期国际泳联世界杯系列赛中包揽多个项目金牌，展现了绝对的统治力。</p>
    <p>乒乓球队方面，新生代选手在国际赛事中表现出色，与老将形成了良性的竞争格局。国乒总教练表示，队伍整体状态良好，备战计划按部就班推进。</p>
    <h2>新兴项目取得突破</h2>
    <p>在滑板、攀岩、冲浪等新兴奥运项目中，中国选手也取得了令人瞩目的进步。特别是在攀岩项目上，中国队在速度攀岩项目上保持了世界领先地位。</p>
    <h2>科技助力备战</h2>
    <p>本次奥运备战中，科技手段的运用达到了新的高度。运动员们配备了智能穿戴设备，训练数据实时监测分析；VR技术被广泛应用于战术模拟训练；营养科学团队为运动员量身定制膳食方案。</p>
    <p>中国体育代表团团长表示，将全力以赴争取在巴黎奥运会上取得优异成绩，展现中国体育的风采。</p>`,
    category: "tiyuzixun",
    coverImage: "https://readdy.ai/api/search-image?query=Olympic%20stadium%20with%20Chinese%20athletes%20training%20in%20modern%20sports%20facility%2C%20dynamic%20action%20shots%2C%20bright%20professional%20lighting%2C%20clean%20composition%2C%20sports%20photography%20style&width=1200&height=600&seq=yunsports-article-1&orientation=landscape",
    author: "体育观察员",
    publishDate: "2026-08-10",
    readTime: "8分钟",
    tags: ["奥运会", "中国代表团", "巴黎", "备战"],
  },
  {
    id: "article-2",
    title: "NBA新赛季前瞻：豪门重组与黑马崛起",
    excerpt: "NBA新赛季即将拉开帷幕，多支球队在休赛期进行了大规模阵容调整，新赛季的竞争格局将迎来重大变化。",
    content: `<p>2026-2027赛季NBA常规赛即将在一个月后拉开帷幕。经历了休赛期的交易市场和自由球员签约，联盟的竞争格局发生了显著变化。</p>
    <h2>冠军争夺者</h2>
    <p>卫冕冠军在休赛期保留了核心阵容，并通过交易补强了替补深度。球队核心在季前训练营中状态出色，仍是新赛季最大的夺冠热门。</p>
    <p>西部劲旅在选秀大会上获得了潜力新星，与当家球星的化学反应正在快速建立。季前赛的几场表现令人眼前一亮，被广泛看好成为西部的有力竞争者。</p>
    <h2>值得关注的新面孔</h2>
    <p>今年的选秀大会涌现出多位天赋异禀的新秀球员。状元秀在夏季联赛中场均贡献超过20分，展现了非凡的得分能力和球场视野，被寄予厚望。</p>
    <h2>规则变化的影响</h2>
    <p>NBA在新赛季对部分比赛规则进行了微调，包括防守三秒的判罚尺度和快攻犯规的界定。这些变化可能会对比赛节奏和战术打法产生深远影响。</p>
    <p>新赛季的NBA注定精彩纷呈，让我们拭目以待。</p>`,
    category: "tiyuzixun",
    coverImage: "https://readdy.ai/api/search-image?query=NBA%20basketball%20game%20action%20with%20players%20dunking%20in%20packed%20arena%2C%20dramatic%20stadium%20lighting%2C%20professional%20sports%20photography%2C%20clean%20composition%2C%20intense%20atmosphere&width=1200&height=600&seq=yunsports-article-2&orientation=landscape",
    author: "篮球观察员",
    publishDate: "2026-08-08",
    readTime: "6分钟",
    tags: ["NBA", "篮球", "新赛季", "前瞻"],
  },
  {
    id: "article-3",
    title: "中国足球超级联赛：争冠形势白热化",
    excerpt: "中超联赛进入关键阶段，积分榜前四名球队积分差距仅有3分，冠军争夺战进入白热化阶段。",
    content: `<p>2026赛季中国足球超级联赛已经进行了三分之二的赛程，冠军争夺形势愈发激烈。目前积分榜前四名球队之间的积分差距仅有3分，任何一场比赛的结果都可能改变排名格局。</p>
    <h2>领头羊稳中有进</h2>
    <p>目前排名榜首的球队在近五轮比赛中取得了四胜一平的出色战绩，球队整体运转流畅，攻防两端都展现出了冠军球队的气质。主教练的战术体系已经被球员们完美消化。</p>
    <h2>追赶者虎视眈眈</h2>
    <p>紧随其后的三支球队同样状态不俗。排名第二的球队拥有联赛最佳射手，进攻火力十足；排名第三的球队防守固若金汤，是联赛失球最少的球队。</p>
    <h2>保级大战同样精彩</h2>
    <p>在积分榜的另一端，保级大战同样扣人心弦。多支球队陷入保级泥潭，每一分都至关重要。接下来的几轮比赛将是保级球队的生死之战。</p>`,
    category: "tiyuzixun",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20football%20super%20league%20match%20with%20players%20in%20action%20on%20green%20pitch%2C%20packed%20stadium%20with%20fans%2C%20professional%20sports%20photography%2C%20dramatic%20lighting%2C%20clean%20composition&width=1200&height=600&seq=yunsports-article-3&orientation=landscape",
    author: "足球评论员",
    publishDate: "2026-08-06",
    readTime: "5分钟",
    tags: ["中超", "足球", "联赛", "争冠"],
  },
  {
    id: "article-4",
    title: "全民健身热潮：城市运动公园成新风尚",
    excerpt: "随着全民健身理念深入人心，越来越多的城市运动公园成为市民日常锻炼的首选场所，运动社交正成为新的生活方式。",
    content: `<p>周末清晨，位于北京市朝阳区的奥林匹克公园内，跑步、骑行、太极拳、广场舞的人群随处可见。这个场景在全国各大城市的运动公园中每天都在上演。</p>
    <h2>运动设施全面升级</h2>
    <p>近年来，各地政府加大了对公共体育设施的投入。智能步道、多功能运动场、户外健身器材等设施不断更新换代。许多公园还配备了智能体质检测设备，市民可以免费进行体质测试。</p>
    <h2>运动社交新趋势</h2>
    <p>运动不再仅仅是个人的健康行为，更成为了一种社交方式。跑步团、骑行俱乐部、飞盘社群等运动团体层出不穷。通过运动认识志同道合的朋友，已经成为年轻人的新社交模式。</p>
    <h2>科技赋能健身</h2>
    <p>智能手表、运动手环等可穿戴设备的普及，让人们能够实时监测自己的运动数据。各种运动APP提供的线上课程和社区功能，让居家健身也变得更加有趣和高效。</p>
    <p>专家表示，全民健身已经成为中国社会的新风尚，这不仅提升了国民身体素质，也带动了体育产业的发展。</p>`,
    category: "jianshenjihua",
    coverImage: "https://readdy.ai/api/search-image?query=Urban%20park%20with%20people%20jogging%20and%20exercising%20in%20morning%20sunlight%2C%20modern%20city%20skyline%20in%20background%2C%20healthy%20lifestyle%20photography%2C%20warm%20natural%20lighting%2C%20clean%20composition&width=1200&height=600&seq=yunsports-article-4&orientation=landscape",
    author: "健身达人",
    publishDate: "2026-08-05",
    readTime: "5分钟",
    tags: ["全民健身", "运动公园", "运动社交", "健康生活"],
  },
  {
    id: "article-5",
    title: "瑜伽入门指南：7个适合新手的基础体式",
    excerpt: "想要开始练习瑜伽但不知从何入手？本文为你介绍7个最适合瑜伽新手的基础体式，帮助你安全有效地开启瑜伽之旅。",
    content: `<p>瑜伽作为一项身心兼修的运动，近年来在国内越来越受欢迎。但对于初学者来说，面对琳琅满目的瑜伽课程和复杂的体式名称，可能会感到无从下手。本文为你介绍7个最适合新手的基础体式。</p>
    <h2>1. 山式</h2>
    <p>山式是瑜伽中最基础的站立体式，看似简单却蕴含了瑜伽的核心要义——正确的站姿和身体排列。双脚并拢或与髋同宽，收紧大腿肌肉，脊柱向上延伸，肩膀放松下沉。</p>
    <h2>2. 下犬式</h2>
    <p>下犬式是最经典的瑜伽体式之一，能够全面拉伸身体后侧肌肉链，同时增强上肢力量。初学者可以将膝盖微微弯曲，重点是保持脊柱的延展。</p>
    <h2>3. 战士一式</h2>
    <p>战士一式能够增强腿部力量，打开髋部和胸腔。前腿屈膝90度，后腿伸直蹬地，双手向上伸展，保持深长的呼吸。</p>
    <p>更多体式请继续学习我们的瑜伽课程。</p>`,
    category: "yundongkecheng",
    coverImage: "https://readdy.ai/api/search-image?query=Woman%20practicing%20yoga%20in%20bright%20minimalist%20studio%20with%20natural%20light%2C%20peaceful%20atmosphere%2C%20clean%20wooden%20floor%2C%20wellness%20lifestyle%20photography%2C%20soft%20warm%20tones&width=1200&height=600&seq=yunsports-article-5&orientation=landscape",
    author: "瑜伽教练",
    publishDate: "2026-08-03",
    readTime: "7分钟",
    tags: ["瑜伽", "入门", "基础体式", "健身"],
  },
  {
    id: "article-6",
    title: "电竞入选亚运会正式项目：数字体育新时代",
    excerpt: "电子竞技正式成为亚运会比赛项目，标志着数字体育进入全新发展阶段，引发社会广泛关注和讨论。",
    content: `<p>随着电子竞技的快速发展和全球影响力的不断扩大，电竞已经正式被列为亚运会的正式比赛项目。这一里程碑事件标志着数字体育进入了全新的发展阶段。</p>
    <h2>电竞产业的发展历程</h2>
    <p>从最初的小众娱乐到如今的全球性体育项目，电子竞技走过了一段不平凡的旅程。据最新数据，全球电竞观众已经超过5亿人，产业规模持续扩大。</p>
    <h2>中国电竞的成绩与展望</h2>
    <p>中国电竞选手在国际赛场上屡创佳绩。在英雄联盟、王者荣耀等主流电竞项目中，中国战队多次获得世界冠军。亚运会上，中国队有望在多个电竞项目中冲击金牌。</p>
    <h2>社会认知的转变</h2>
    <p>随着电竞入亚，社会对电子竞技的认知也在发生积极转变。越来越多的人开始将电竞视为一种需要天赋、训练和团队协作的竞技运动，而非简单的"打游戏"。</p>`,
    category: "saishizhibo",
    coverImage: "https://readdy.ai/api/search-image?query=E-sports%20arena%20with%20professional%20gamers%20competing%20on%20stage%2C%20massive%20LED%20screens%2C%20packed%20audience%2C%20dramatic%20stage%20lighting%2C%20cyberpunk%20aesthetic%20with%20clean%20composition&width=1200&height=600&seq=yunsports-article-6&orientation=landscape",
    author: "电竞观察员",
    publishDate: "2026-08-01",
    readTime: "6分钟",
    tags: ["电竞", "亚运会", "数字体育", "电竞入亚"],
  },
  {
    id: "article-7",
    title: "科学减脂全攻略：饮食与运动的黄金配比",
    excerpt: "想要健康减脂？本文从科学角度出发，为你解析减脂过程中饮食与运动的最佳配比方案。",
    content: `<p>减脂是许多健身爱好者的核心目标，但如何科学有效地减脂却是一门学问。本文将基于运动科学原理，为你解析减脂过程中饮食与运动的最佳配比方案。</p>
    <h2>热量缺口是关键</h2>
    <p>减脂的核心原理是创造热量缺口——即消耗的热量大于摄入的热量。一般建议每天创造300-500大卡的热量缺口，这样每周可以健康减掉0.5-1公斤脂肪。</p>
    <h2>饮食策略</h2>
    <p>在饮食方面，建议采用高蛋白、适量碳水、低脂肪的饮食结构。每日蛋白质摄入量建议为每公斤体重1.6-2.2克，以维持肌肉量并增加饱腹感。</p>
    <h2>运动方案</h2>
    <p>最优的减脂运动方案是力量训练与有氧运动的结合。每周3-4次力量训练配合2-3次有氧运动，能够在减脂的同时最大限度地保留甚至增加肌肉量。</p>`,
    category: "jianshenjihua",
    coverImage: "https://readdy.ai/api/search-image?query=Healthy%20meal%20prep%20with%20fresh%20ingredients%20alongside%20fitness%20equipment%2C%20clean%20modern%20kitchen%20setting%2C%20bright%20natural%20light%2C%20wellness%20lifestyle%20photography%2C%20warm%20neutral%20tones&width=1200&height=600&seq=yunsports-article-7&orientation=landscape",
    author: "营养师小王",
    publishDate: "2026-07-28",
    readTime: "8分钟",
    tags: ["减脂", "饮食", "运动", "科学健身"],
  },
  {
    id: "article-8",
    title: "网球大师赛精彩回顾：巅峰对决创造历史",
    excerpt: "刚刚结束的网球大师赛决赛堪称经典，两位世界顶级选手上演了五盘大战，为观众奉献了一场史诗级的对决。",
    content: `<p>在刚刚结束的2026年网球大师赛决赛中，两位世界排名前三的选手上演了一场精彩绝伦的五盘大战，最终经过4小时28分钟的鏖战才分出胜负。</p>
    <h2>比赛回顾</h2>
    <p>首盘比赛，卫冕冠军展现出强大的发球状态，以6-3先下一城。但挑战者迅速调整状态，凭借出色的底线防守和精准的穿越球，以7-5扳回一盘。</p>
    <h2>关键时刻</h2>
    <p>决胜盘中，双方战至6-6平进入抢七。在抢七局中，挑战者凭借连续两个ACE球拿下比赛，创造了个人职业生涯的又一个里程碑。</p>
    <h2>赛后反响</h2>
    <p>赛后，这场比赛被媒体和球迷誉为"年度最佳比赛"。网球传奇人物在社交媒体上发文称赞这是一场"将载入史册的经典对决"。</p>`,
    category: "saishizhibo",
    coverImage: "https://readdy.ai/api/search-image?query=Tennis%20player%20serving%20in%20grand%20slam%20stadium%20with%20dramatic%20sunset%20lighting%2C%20professional%20sports%20photography%2C%20dynamic%20action%20shot%2C%20clean%20composition%2C%20intense%20atmosphere&width=1200&height=600&seq=yunsports-article-8&orientation=landscape",
    author: "网球评论员",
    publishDate: "2026-07-25",
    readTime: "5分钟",
    tags: ["网球", "大师赛", "决赛", "经典对决"],
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((article) => article.id === id);
};